// A card form's date and time field. The browser's <input type="datetime-local"> holds a time with no zone
// ("2026-10-26T16:30", read as the person's own clock). The room reads a string with no offset in its own zone, which
// is UTC, so the form sends an instant instead (#251).

const pad = (n: number) => String(n).padStart(2, "0");
const LOCAL = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/;

/** What the field sends: the instant, as ISO 8601 in UTC with "Z". Empty or unreadable gives "". */
export function datetimeToSend(value: string): string {
  // new Date() reads a date-time with no offset as the browser's own clock.
  const t = new Date(value).getTime();
  return value && Number.isFinite(t) ? new Date(t).toISOString() : "";
}

/**
 * What the field shows for a held value: an instant (ms, or ISO 8601 with an offset) or a local "YYYY-MM-DDTHH:mm".
 * `seconds`: a field with a step under a minute shows the seconds too, or it would drop them on every change.
 */
export function datetimeToShow(value: unknown, seconds = false): string {
  if (typeof value === "string" && LOCAL.test(value)) return value;
  const t = typeof value === "number" ? value : typeof value === "string" && value ? Date.parse(value) : NaN;
  if (!Number.isFinite(t)) return "";
  const d = new Date(t);
  const sec = seconds ? `:${pad(d.getSeconds())}` : "";
  return `${String(d.getFullYear()).padStart(4, "0")}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}${sec}`;
}
